export default {
  tabs: {
    online_shop: 'Verkkokauppa',
    reservations: 'Varaukset',
    storefront: 'Storefront',
  },
};
